import React, { Component } from 'react';
import { Table, Icon, Popconfirm, Row, Button, Modal, message, Input, Spin, Select, Tree, Col, Upload } from 'antd';
import { Link } from "react-router-dom";
import './index.scss';
import DisplaySwitch from "./DisplaySwitch";
import { authData } from "./data";
import { incomeRange } from "@/method/data"

const Option = Select.Option;
const TreeNode = Tree.TreeNode;

const authName = [{
    name: "GM/HM 总经理/酒店经理",
    value: "GM"
}, {
    name: "RM/EAM 驻店经理/行政助理经理",
    value: "EAM"
}, {
    name: "DOF 财务总监",
    value: "DOF"
}, {
    name: "FM 财务经理",
    value: "FIN"
}, {
    name: "Income Audit",
    value: "IA"
}, {
    name: "DHR 人力资源总监",
    value: "HR"
}, {
    name: "DOSM 市场营销总监",
    value: "SM"
}, {
    name: "DFB 餐饮总监",
    value: "FB"
}, {
    name: "DOC 宴会统筹总监",
    value: "BQT"
}, {
    name: "DOR 房务总监/EHK 行政管家/FOM 前厅经理",
    value: "Rooms"
}, {
    name: "DOE 工程总监",
    value: "ENG"
}, {
    name: "REVM 收益经理",
    value: "REV"
}, {
    name: "Training",
    value: "Training"
}]

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            data: [],
            type: [],
            visible: false,
            loadingSave: false,
            loading: true,
            uplading: false,
            hotel: {
                name: "",
                tel: "",
                address: "",
                contacts: "",
                code: "",
                type: [],
                typename: [],
                img: []
            },
            loadingAuth: false,
            authData: [],
            authVisible: false,
            hotelAuthName: "FIN",
            expandedKeys: [],
            autoExpandParent: true,
            checkedKeys: [],
            selectedKeys: [],
            auth: {},
            authLoading: false,
            info: sessionStorage.getItem('user') ? JSON.parse(sessionStorage.getItem('user')) : {},
            dataTotal: [],
            searchData: {
                name: "",
                abridge: "",
                area: "",
                income: ''
            }
        }
    }

    componentDidMount() {
        this.getData();
    }

    getData = () => {
        fetch('/getHotels', { credentials: 'include' }).then(x => x.json()).then(x => {
            this.setState({ loading: false });
            const hotels = (x.data.hotels || []);
            if (x.status == 1) {
                this.setState({
                    data: hotels,
                    type: x.data.type || [],
                    dataTotal: hotels
                });
                this.onSearch();
                return
            }
            message.error('数据获取失败！' + JSON.stringify(x.msg))
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
            message.error('数据获取失败！' + JSON.stringify(err))
        })
    }

    showModal = () => {
        this.setState({
            visible: true,
        });
    }
    handleOk = (e) => {
        this.setState({ loadingSave: true });
        let data = JSON.parse(JSON.stringify(this.state.hotel));
        if (!data.name || !data.code) {
            message.error('酒店信息不能为空');
            this.setState({ loadingSave: false });
            return
        }
        data.img = JSON.stringify(data.img.map(x => ({
            uid: x.uid,
            url: x.url || (x.response ? x.response.data : '')
        })));
        delete data.typename;
        data.type = (data.type || "").toString();
        delete data.add_time;
        let dataFrom = new FormData();
        for (const key in data) {
            if (data.hasOwnProperty(key)) {
                dataFrom.append(key, data[key] || "");
            }
        }

        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/addHotel', headres).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.info('保存成功！');
                this.getData();
                this.setState({
                    visible: false,
                    loadingSave: false,
                    loading: true,
                    hotel: {
                        name: "",
                        tel: "",
                        address: "",
                        contacts: "",
                        code: ""
                    }
                });
                return
            }
            message.error(x.msg);
            this.setState({
                loadingSave: false
            });

        }).catch(err => {
            console.error(err);
            message.error('数据添加失败！')
            this.setState({
                loadingSave: false
            });
        })
    }
    handleCancel = (e) => {
        this.setState({
            visible: false,
            hotel: {
                name: "",
                tel: "",
                address: "",
                contacts: ""
            }
        });
    }

    getAuthData = () => {
        fetch('/getAuth?user=' + this.state.hotelAuthName, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data && x.data.length > 0) {
                let checkedKeys = x.data[0].data.split(',');
                this.setState({
                    auth: x.data[0],
                    checkedKeys,
                    authLoading: false
                });
            } else {
                this.setState({
                    auth: {},
                    checkedKeys: [],
                    authLoading: false
                });
            }

        }).catch(err => {
            console.error(err);
            this.setState({
                authLoading: false
            });
        })
    }

    // 权限
    authshowModal = () => {
        if (this.state.info.email != 'admin') {
            message.error('权限不足！')
            return
        }
        this.setState({
            authVisible: true,
            authLoading: true
        });
        this.getAuthData();

    }
    authhandleOk = (e) => {
        if (this.state.info.email != 'admin') {
            message.error('权限不足！')
            return
        }
        this.setState({ loadingAuth: true });
        let checkedKeys = this.state.checkedKeys;
        let hotelAuthName = this.state.hotelAuthName;
        // console.log(checkedKeys)
        let data = {
            ...this.state.auth,
            user: hotelAuthName,
            data: checkedKeys.toString(),
        }

        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/addAuth', headres).then(x => x.json()).then(x => {
            this.setState({ loadingAuth: false });
            if (x.status == 1) {
                message.success('保存成功');
                return
            }

            message.error('保存失败！')
        }).catch(err => {
            console.error(err);
            this.setState({ loadingAuth: false });
        })

    }
    authhandleCancel = (e) => {
        this.setState({
            authVisible: false,
        });
    }

    onChange = (value, lable, extra) => {
        this.setState({
            selectAuth: value
        });
    }

    onExpand = (expandedKeys) => {
        // if not set autoExpandParent to false, if children expanded, parent can not collapse.
        // or, you can remove all expanded children keys.
        this.setState({
            expandedKeys,
            autoExpandParent: false,
        });
    }
    onCheck = (checkedKeys, checkedNodes) => {
        this.setState({ checkedKeys });
    }
    onSelect = (selectedKeys, info) => {
        this.setState({ selectedKeys });
    }

    renderTreeNodes = (data) => {
        return data.map((item) => {
            if (item.children) {
                return (
                    <TreeNode title={item.title} key={item.key} dataRef={item}>
                        {this.renderTreeNodes(item.children)}
                    </TreeNode>
                );
            }
            return <TreeNode {...item} />;
        });
    }

    onSearch = () => {
        const { dataTotal, searchData: { name = "", abridge = "", area = "", income = "" } } = this.state;

        let data = dataTotal.filter(x => {
            return (x.name || "").trim().includes(name)
                && (x.code || "").trim().toUpperCase().includes(abridge.trim().toUpperCase())
                && (x.area || "").trim().includes(area)
                && (x.income_interval == income || !income)
        });

        this.setState({
            data
        });
    }

    onDeleteHotel = (data) => {
        fetch(`/deleteHotel?id=${data.id}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.info('删除成功！');
                this.getData();
                return
            }

            message.error(x.msg);
        }).catch(err => {
            console.error(err);
        })
    }
    resetPassword = (data) => {
        fetch('/resetPassword?id=' + data.id, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.status == 1) {
                message.info('密码重置成功，请牢记新密码: 1212');
                return
            }
            message.error('操作失败！');
        }).catch(err => {
            message.error('操作失败！');
            console.error(err);
        })
    }
    render() {
        const { searchData, data, hotel, uplading } = this.state;
        const uploadButton = (
            <div>
                <Icon type={uplading ? 'loading' : 'plus'} />
                <div className="ant-upload-text">{uplading ? '上传中...' : '上传'}</div>
            </div>
        );
        const columns = [{
            title: '序号',
            dataIndex: 'id',
            key: 'id',
        }, {
            title: '酒店名称',
            dataIndex: 'name',
            key: 'name',
            render: (text, record) => {
                return (
                    <Link to={`/table/hotel/${record.id}`}>{text}</Link>
                )
            }
        }, {
            title: '缩写',
            dataIndex: 'code',
            key: 'code',
        }, {
            title: '性质',
            dataIndex: 'nature',
            key: 'nature',
        }, {
            title: '开业时间',
            dataIndex: 'openDate',
            key: 'openDate',
        }, {
            title: '集团合同到期日',
            dataIndex: 'groupExpireDate',
            key: 'groupExpireDate',
        }, {
            title: '温德姆编码',
            dataIndex: 'wdm_number',
            key: 'wdm_number',
        }, {
            title: '区域',
            key: 'area',
            dataIndex: 'area',
        }, {
            title: '收入区间',
            key: 'income_interval',
            dataIndex: 'income_interval',
            render: (text, record) => {
                return incomeRange[text] || ""
            }
        }, {
            title: '操作',
            key: 'add_time',
            render: (record) => {
                return (
                    <div>
                        <Link to={`/table/hotel/${record.id}`}>查看</Link>
                        <Icon type="minus" />
                        <span
                            style={{ color: "#1890ff", cursor: "pointer" }}
                            onClick={() => {
                                let thistype = (record.type || "").split(',')
                                let typename = [];
                                thistype.forEach(element => {
                                    (this.state.type || []).forEach(item => {
                                        if (item.id == element) {
                                            typename.push(item.name)
                                        }
                                    })
                                });
                                let hotel = { ...record, type: (record.type || "").split(','), typename: typename }
                                this.setState({
                                    hotel,
                                    visible: true
                                });
                                console.log(this.state.hotel.type)
                            }}
                        >编辑</span>
                        <Icon type="minus" />
                        <Popconfirm
                            title="确定要删除酒店?"
                            onConfirm={this.onDeleteHotel.bind(this, record)}
                            onCancel={() => { }}
                            okText="是"
                            cancelText="否"
                        >
                            <span
                                style={{ color: "#1890ff", cursor: "pointer" }}
                            >删除</span>
                        </Popconfirm>
                        <span>
                            <Icon type="minus" />
                            <Popconfirm
                                title="确定要重置密码吗?"
                                onConfirm={this.resetPassword.bind(this, record)}
                                onCancel={() => { }}
                                okText="是"
                                cancelText="否"
                            >
                                <span style={{ color: "#1890ff", cursor: "pointer" }} >重置密码</span>
                            </Popconfirm>
                        </span>
                    </div>
                )
            }
        }];
        return (

            <div className='settings'>
                <Row style={{ margin: '20px 0' }}>
                    <span>酒店名称：</span>
                    <Input
                        style={{ width: 150, margin: "0 10px" }}
                        value={searchData.name}
                        onChange={(e) => {
                            this.setState({
                                searchData: { ...searchData, name: e.target.value || "" }
                            });
                        }}
                        onPressEnter={this.onSearch}
                    />
                    <span>缩写：</span>
                    <Input
                        style={{ width: 150, margin: "0 10px" }}
                        value={searchData.abridge}
                        onChange={(e) => {
                            this.setState({
                                searchData: { ...searchData, abridge: e.target.value || "" }
                            });
                        }}
                        onPressEnter={this.onSearch}
                    />
                    <span>区域：</span>
                    <Input
                        style={{ width: 150, margin: "0 10px" }}
                        value={searchData.area}
                        onChange={(e) => {
                            this.setState({
                                searchData: { ...searchData, area: e.target.value || "" }
                            });
                        }}
                        onPressEnter={this.onSearch}
                    />
                    <span>收入区间：</span>
                    <Select
                        allowClear
                        value={searchData.income}
                        style={{ width: 200, margin: "0 10px" }}
                        onChange={(value) => {
                            this.setState({
                                searchData: { ...searchData, income: value || "" }
                            });
                        }}
                    >
                        <Option value="1">一亿以上</Option>
                        <Option value="2">8000万-1亿</Option>
                        <Option value="3">6500万-8000万</Option>
                        <Option value="4">5500万-6500万</Option>
                        <Option value="5">4500万-5500万</Option>
                        <Option value="6">3500万-4500万</Option>
                        <Option value="7">2000万-3500万</Option>
                        {/* <Option value="8">2000万-2500万</Option> */}
                        <Option value="9">1000万-2000万</Option>
                        <Option value="10">小于1000万</Option>
                    </Select>
                    <Button
                        type="primary"
                        onClick={this.onSearch}
                    >搜索</Button>
                    <Button
                        style={{ margin: "0 10px" }}
                        onClick={() => {
                            this.setState({
                                searchData: {
                                    name: "",
                                    abridge: "",
                                    area: "",
                                    income: ''
                                }
                            }, () => {
                                this.onSearch();
                            });
                        }}
                    >重置</Button>
                </Row>
                <Row style={{ margin: '20px 0' }}>
                    <Col span={12}>
                        <Button
                            type="primary"
                            onClick={this.showModal}
                            style={{ marginRight: 10 }}
                        >新增酒店</Button>
                        <Button
                            type="primary"
                            onClick={() => {
                                this.props.history.push('/table/labelmanagement')
                            }}
                        >酒店标签</Button>
                    </Col>
                    <Col span={12}>
                        <Row type="flex" justify="end">
                            <DisplaySwitch />
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.props.history.push('/table/BpSave');
                                }}
                                style={{ marginRight: 10 }}
                            >BP保存权限设置</Button>
                            <Button
                                type="primary"
                                onClick={() => {
                                    this.props.history.push('/table/headquarters');
                                }}
                                style={{ marginRight: 10 }}
                            >总部人员管理</Button>
                            <Button
                                type="primary"
                                onClick={this.authshowModal}
                            >权限设置</Button>
                        </Row>
                    </Col>
                </Row>

                <Spin spinning={this.state.loading}>
                    <Table
                        style={{ marginTop: 20 }}
                        columns={columns}
                        dataSource={data}
                        bordered

                        rowKey={(item, index) => index}
                    />
                </Spin>
                <Modal
                    title={this.state.hotel.id ? '酒店编辑' : "酒店添加"}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={this.handleCancel}
                    footer={[
                        <Button key="back" onClick={this.handleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingSave} onClick={this.handleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <Row className="modal">
                        <Row>
                            <span>酒店名称：</span>
                            <Input
                                placeholder="请输入酒店名称"
                                style={{ width: '60%', marginLeft: 24 }}
                                value={this.state.hotel.name}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.name = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                        </Row>
                        <Row className="settings-modal-content">
                            <span>区域：</span>
                            <Select
                                allowClear
                                value={this.state.hotel.area}
                                style={{ width: '60%', marginLeft: 50 }}
                                onChange={(value) => {
                                    let hotel = this.state.hotel;
                                    hotel.area = value || "";
                                    this.setState({
                                        hotel
                                    });
                                }}
                            >
                                <Option value="东南华南">东南华南</Option>
                                <Option value="华北华中">华北华中</Option>
                                <Option value="江浙沪皖">江浙沪皖</Option>
                                <Option value="西南">西南</Option>
                                <Option value="华东">华东</Option>
                            </Select>
                        </Row>
                        <Row className="settings-modal-content">
                            <span>收入区间：</span>
                            <Select
                                allowClear
                                value={this.state.hotel.income_interval}
                                style={{ width: '60%', marginLeft: 24 }}
                                onChange={(value) => {
                                    let hotel = this.state.hotel;
                                    hotel.income_interval = value || "";
                                    this.setState({
                                        hotel
                                    });
                                }}
                            >
                                {
                                    Object.entries(incomeRange).map(x => {
                                        return <Option value={x[0]}>{x[1]}</Option>
                                    })
                                }
                            </Select>
                        </Row>
                        {/* <Row className="settings-modal-content">
                            <span>酒店标签：</span>
                            <Select
                                mode="multiple"
                                value={this.state.hotel.typename}
                                style={{ width: '60%', marginLeft: 24 }}
                                onChange={(value) => {
                                    let hotel = this.state.hotel;
                                    hotel.type = (value || []).map(x => (this.state.type.find(item => item.name == x) || {})['id']);
                                    hotel.typename = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            >
                                {(this.state.type || []).map(item => {
                                    return <Option key={item.name}  >{item.name}</Option>
                                })}
                            </Select>
                        </Row> */}
                        <Row className="settings-modal-content">
                            <span>联系人：</span>
                            <Input
                                placeholder="请输入联系人"
                                style={{ width: '60%', marginLeft: 38 }}
                                value={this.state.hotel.contacts}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.contacts = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                        </Row>
                        <Row className="settings-modal-content">
                            <span>酒店地址：</span>
                            <Input
                                placeholder="请输入酒店地址"
                                style={{ width: '60%', marginLeft: 24 }}
                                value={this.state.hotel.address}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.address = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                        </Row>
                        <Row className="settings-modal-content">
                            <span>联系电话：</span>
                            <Input
                                placeholder="请输入联系电话"
                                style={{ width: '60%', marginLeft: 24 }}
                                value={this.state.hotel.tel}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.tel = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                        </Row>
                        <Row className="settings-modal-content">
                            <span>代码标识：</span>
                            <Input
                                placeholder="请输入代码标识"
                                style={{ width: '60%', marginLeft: 24 }}
                                value={this.state.hotel.code}
                                disabled={this.state.hotel.id}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.code = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                        </Row>
                        <Row className="settings-modal-content">
                            <span>温德姆编码：</span>
                            <Input
                                placeholder="请输入代码标识"
                                style={{ width: '60%', marginLeft: 10 }}
                                value={this.state.hotel.wdm_number}
                                onChange={(e) => {
                                    let value = e.target.value;
                                    let hotel = this.state.hotel;
                                    hotel.wdm_number = value;
                                    this.setState({
                                        hotel
                                    });
                                }}
                            />
                        </Row>
                        <Row className="list-item">
                            <span className='label'>酒店图片：</span>
                            <Upload
                                className='value'
                                action="/qiansheng/open/upload"
                                listType="picture-card"
                                fileList={hotel.img}
                                onChange={info => {
                                    this.setState({ hotel: { ...hotel, img: info.fileList } });
                                    if (info.file.status === 'uploading') {
                                        this.setState({ uplading: true });
                                        return;
                                    }
                                    if (info.file.status === 'done') {
                                        this.setState({
                                            uplading: false,
                                        })
                                    }
                                }}
                            >
                                {(hotel.img || []).length >= 8 ? null : uploadButton}
                            </Upload>
                        </Row>
                    </Row>
                </Modal>

                <Modal
                    title='权限设置'
                    visible={this.state.authVisible}
                    onOk={this.authhandleOk}
                    onCancel={this.authhandleCancel}
                    footer={[
                        <Button key="back" onClick={this.authhandleCancel}>取消</Button>,
                        <Button key="submit" type="primary" loading={this.state.loadingAuth} onClick={this.authhandleOk}>
                            保存
                        </Button>,
                    ]}
                >
                    <Spin spinning={this.state.authLoading}>
                        <Row className="modal">
                            <Row>
                                <span>选择人员：</span>
                                <Select
                                    value={this.state.hotelAuthName}
                                    style={{ width: 300 }}
                                    onChange={(value) => {
                                        this.setState({
                                            hotelAuthName: value,
                                            authLoading: true
                                        }, () => {
                                            this.getAuthData()
                                        });
                                    }}
                                >

                                    {authName.map((x, i) => {
                                        return (
                                            <Option key={x.value}>{x.name}</Option>
                                        )
                                    })}
                                </Select>
                            </Row>
                            <Row className="authCotent">
                                <Row>权限配置</Row>
                                <Tree
                                    checkable
                                    // checkStrictly={true}
                                    onExpand={this.onExpand}
                                    expandedKeys={this.state.expandedKeys}
                                    autoExpandParent={this.state.autoExpandParent}
                                    onCheck={this.onCheck}
                                    checkedKeys={this.state.checkedKeys}
                                    onSelect={this.onSelect}
                                    selectedKeys={this.state.selectedKeys}
                                >
                                    {this.renderTreeNodes(authData)}
                                </Tree>
                            </Row>
                        </Row>
                    </Spin>
                </Modal>
            </div>

        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/setting/index.js